<template>
    <vue-tel-input
        :input-options="inputOptions"
        :default-country="defaultCountry"
        :all-countries="allCountries"
        :valid-characters-only="true"
        :mode="'international'"
        v-model="internalValue"
        @open="onDropdownOpen"
        @close="onDropdownClose"
    />
</template>

<script>
    import { getListOfCountriesWithDialCode } from "./countryListProvider";
    import translatorMixin from "./translatorMixin";

    /**
     * Pay attention where this component is used as it contains dropdown.
     * If e.g. modal where there is not enough space for the dropdown,
     * it will be cut off due to absolute positioning.
     *
     * To mitigate this, you need to react to dropdownOpen and dropdownClose events
     * and adjust the container height accordingly.
     */
    export default {
        name: "phone-number-input",
        mixins: [translatorMixin],
        props: ["modelValue"],
        data() {
            const allCountries = getListOfCountriesWithDialCode().map(dialCode => {
                return {
                    ...dialCode,
                    name: this.translate("country." + dialCode.iso2.toUpperCase()),
                };
            });

            return {
                allCountries: allCountries,
                inputOptions: {
                    placeholder: "",
                    required: true,
                    name: "phone",
                },
                defaultCountry: window.acceptedLanguageRegion,
            };
        },
        computed: {
            internalValue: {
                set(newValue) {
                    this.$emit("update:modelValue", newValue);
                },
                get() {
                    return this.modelValue;
                },
            },
        },
        methods: {
            onDropdownOpen() {
                this.$emit("dropdownOpen");
            },
            onDropdownClose() {
                this.$emit("dropdownClose");
            },
        },
    };
</script>

<style scoped></style>
